import { create } from "zustand"
import { DeviceType } from "../models/constants/deviceType";
import { AccessMode } from "../models/constants/accessMode";

interface DeviceState {
    deviceType: string;
    accessModeSource: {
        sourceType: string;
    }
}

const initialState: DeviceState = {
    deviceType: DeviceType.Web,
    accessModeSource: {
        sourceType: AccessMode.Web,
    }
};

const userDeviceStore = create<DeviceState>((set) => ({
    ...initialState,
    setDeviceType: (deviceType: string) => set({ deviceType }),
    setAccessModeSource: (accessModeSource: { sourceType: string }) => set({ accessModeSource }),
}));


export default userDeviceStore;

